import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getCookie } from '../helpers/Cookies';
import { cstToUTC } from '../Common/CommonHelper';

const getCountUpStickyTimer = (stickyTimerDetails) => {
    try {
        const { redeemingChannel = '', stickyTimerUrl = '' } = stickyTimerDetails;
        const redeemingChannelLink = redeemingChannel
            ? `&redeemingChannel=${redeemingChannel}`
            : '';
        const config = {
            url: `${stickyTimerUrl}${redeemingChannelLink}`,
            apiHost: apiHosts.content,
            excludeVersion: true,
            isXCloudHeaderRequired: true,
        };
        const context = RestClient.getContext();
        if (context.isPreview) {
            const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
            // Check for the Preview Environment Date
            config.previewDate = (dateValue || new Date()).toISOString();
        }
        return RestClient.get(config).then((json) => json);
    } catch (e) {
        return e;
    }
};

export default getCountUpStickyTimer;
